import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import { Colors } from "../../../theme/colors";
import { FontSizes } from "../../../theme/fonts";

type TextType = "h1" | "h2" | "h3" | "p";

interface TextProps {
  children?: ReactNode;
  color?: string;
  type: TextType;
  className?: string;
  style?: React.CSSProperties;
}

const Text = ({ children, color, type, className, style }: TextProps) => {
  return (
    <Label type={type} color={color} className={className} style={style}>
      {children}
    </Label>
  );
};

const Label = styled.label<{
  type: TextType;
  color?: string;
}>`
  ${(props) => {
    switch (props.type) {
      case "h1":
        return css`
          color: ${Colors.Primary};
          font-weight: bold;
          font-size: ${FontSizes.Header1};
        `;
      case "h2":
        return css`
          color: ${Colors.Primary};
          font-weight: bold;
          font-size: ${FontSizes.Header2};
        `;
      case "h3":
        return css`
          color: ${Colors.Primary};
          font-weight: bold;
          font-size: ${FontSizes.Header3};
        `;
      case "p":
        return css`
          color: ${Colors.Black};
          font-weight: normal;
          font-size: ${FontSizes.Paragraph};
        `;
    }
  }}

  ${(props) => {
    if (props.color !== undefined)
      return css`
        color: ${props.color};
      `;
  }}

  white-space: pre-wrap;
`;

export default Text;
